import {Injectable} from '@angular/core';
import {ApModalComponentType} from 'webcommon/core-ui';
import {FindControlIdService} from 'webcommon/legacy-common';
import { FcGenericListModalComponent } from './fc-item-modals/fc-generic-list-modal/fc-generic-list-modal.component';
import { FcItemModalBaseComponent } from './generic/fc-item-modal-base.component';

@Injectable({
  providedIn: 'root',
})
export class FcItemConfig {

  readonly fcItemModalById = new Map<string, ApModalComponentType<FcItemModalBaseComponent>>();
  readonly defaultItemModal: ApModalComponentType<FcItemModalBaseComponent> = FcGenericListModalComponent;

  constructor(
    findControlIdService: FindControlIdService,
  ) {
    this.fcItemModalById.set(findControlIdService.ListAmendmentSource, FcGenericListModalComponent);
    this.fcItemModalById.set(findControlIdService.ListHistorian, FcGenericListModalComponent);
  }
}
